export const SYSTEM_LOG_DEBOUNCE_MS = 400;

export const SYSTEM_LOG_SCOPE_FILTER_KEYS = Object.freeze([
    'search',
    'action',
    'actionFamilies',
    'resource',
    'resourceId',
    'user',
    'status',
    'severity',
    'category',
    'dateFrom',
    'dateTo',
    'ip',
    'requestId',
    'sessionId',
]);

export function getActiveSystemLogFilters(searchParams = {}) {
    return SYSTEM_LOG_SCOPE_FILTER_KEYS
        .filter((key) => {
            const value = searchParams[key];
            return Array.isArray(value) ? value.length > 0 : Boolean(value);
        })
        .map((key) => ({
            key,
            value: searchParams[key],
            mode: key === 'action' ? searchParams.actionMode || 'contains' : undefined,
        }));
}

function toLocalDateInput(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function getLocalDateShortcut(days, now = new Date()) {
    const safeDays = Math.max(1, Math.trunc(days));
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const start = new Date(end);
    start.setDate(start.getDate() - (safeDays - 1));
    return { dateFrom: toLocalDateInput(start), dateTo: toLocalDateInput(end) };
}

export function scopeChanged(overrides = {}) {
    return SYSTEM_LOG_SCOPE_FILTER_KEYS.some((key) => Object.hasOwn(overrides, key));
}

export class LatestRequestGate {
    constructor() {
        this.sequence = 0;
    }

    begin(scope) {
        return { sequence: ++this.sequence, scope: String(scope ?? '') };
    }

    isLatest(token, scope) {
        return Boolean(token)
            && token.sequence === this.sequence
            && token.scope === String(scope ?? '');
    }
}
